import _ from 'lodash';
import React from 'react';

import {
  PaymentMethodName,
  usePaymentMethodSelectFieldQuery
} from 'generated/graphql';



export interface IPaymentMethod {
  id: PaymentMethodName;
  displayName: string;
}

export interface IData {
  objects: IPaymentMethod[];
}

export function useQuery() {
  const queryTuple = usePaymentMethodSelectFieldQuery();

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.paymentMethods ?? [], (node): IPaymentMethod => ({
        id: node.name,
        displayName: node.displayName
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
